import React from "react";
import S from "./DeveloperDocs.styled";
import { Flex } from "@/styles/global";
import { IWPLink, IWPTitleParts } from "@/src/types";
import { CardLink } from "@/styles/components";
import { H3 } from "@/styles/typography";
import TitleParts from "@/components/global-components/TitleParts";

export interface DeveloperDocsProps {
  blockId: string;
  backgroundType: "card" | "fill";
  titleParts: IWPTitleParts;
  title: string;
  links: {
    category: string;
    title: string;
    link: IWPLink;
  }[];
}

const DeveloperDocs: React.FC<DeveloperDocsProps> = ({
  titleParts,
  title,
  links,
  backgroundType,
  blockId = "",
}) => {
  backgroundType = backgroundType || "fill";

  return (
    <S.Section $backgroundType={backgroundType} id={blockId}>
      <S.Inner>
        <S.Card $backgroundType={backgroundType}>
          <S.Title>
            {titleParts ? (
              <TitleParts
                titleParts={titleParts}
                backgroundColor={backgroundType === "fill" ? "creme" : "white"}
              />
            ) : (
              title && title
            )}
          </S.Title>
          {links?.map((link, i) => {
            return (
              <S.Wrapper key={i} href={link.link.url} target={link.link.target}>
                <Flex $column $gap={8}>
                  {link.category && <S.Text size={16}>{link.category}</S.Text>}
                  <H3>{link.title}</H3>
                </Flex>
                <CardLink label="Read more" width="max-content" color="black" />
              </S.Wrapper>
            );
          })}
        </S.Card>
      </S.Inner>
    </S.Section>
  );
};

export default DeveloperDocs;
